import React from 'react';
import {Input} from 'semantic-ui-react';

export const Filter = ({column}) => {
  return (
    <div>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  'column': {
    filterValue,
    setFilter,
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    />
  );
};
